import { useContext, useEffect, useState } from "react";
import courseContext from '../../../Helper/Courses'
import { Table } from "antd"
import CommonModal from "../../UiKits/Modals/common/modal"
import { Btn } from "../../../AbstractElements";
import Loader from '../../../Common/Component/Loader'
import { FEE_STATUS, NOT_VERIFIED, PENDING, VERIFIED } from "../../../Constant";
import { Input, Label } from "reactstrap";
import { toast } from "react-toastify";
import { getFormattedTimings } from '../../../utils/course'
import { firebaseFunction } from "../../../firebase/init";
import StudentContext from "../../../Helper/Students";
import { addAdminActivity, changeStudentCourse } from "../../../firebase/utils";
import AdminContext from "../../../Helper/admin";

const screenShotReasons = [
  "The screenshot does not contain any of the following details: Transaction ID, Date, Time, and Amount",
  "Other",
];

const FeeUpdate = ({ data, open, setOpen, module, updateStudents, courseStudents }) => {
  const { activeCourse } = useContext(courseContext)
  const { user, location } = useContext(AdminContext)
  const { students, setStudents } = useContext(StudentContext)
  const [feeImage, setFeeImage] = useState('')
  const [showImage, setShowImage] = useState(false)
  const [feeStatus, setFeeStatus] = useState("")
  const [openTextBox, setOpenTextBox] = useState(false);
  const [loading, setLoading] = useState(false)
  const [textBox, setTextBox] = useState("");
  const [reason, setReason] = useState('')

  const feeStatusChangeHandler = (e) => {
    if (
      e.target.value !== NOT_VERIFIED ||
      (e.target.value !== PENDING && openTextBox)
    ) {
      setOpenTextBox(false);
    } else if (reason === "Other") {
      setOpenTextBox(true);
    }
    setFeeStatus(e.target.value);
  }

  const reasonChangeHandler = (e) => {
    const value = e.target.value;
    if (value === "Other") {
      setOpenTextBox(true);
      setReason(value);
    } else {
      setReason(value);
      setOpenTextBox(false);
    }
  }

  const saveStudentUpdatedFee = async () => {
    const studentFee = data.courses[data.courseIndex].feeScreenshots[module]
    const status = studentFee?.status
    if (status === feeStatus) return
    if (feeStatus === NOT_VERIFIED) {
      if (!reason || (reason === "Other" && !textBox)) {
        toast.error(
          `Please ${reason === "Other" && !textBox ? "enter" : "select"
          } a reason for the failed screenshot`
        );
        return;
      }
    }
    setLoading(true);
    try {

      if (reason) {
        if (reason != "Other") {
          data.courses[data.courseIndex].feeScreenshots[module].reason =
            reason;
        } else {
          data.courses[data.courseIndex].feeScreenshots[module].reason =
            textBox;
        }
      }
      studentFee.status = feeStatus;

      let sendEmail = firebaseFunction.httpsCallable('sendEmail')
      const activityOptions = {
        adminId: user.email,
        activityOnUser: data.email,
        type: FEE_STATUS,
        createdAt: new Date(),
        activity: `${user.email} ${feeStatus} ${data.email}'s fees for ${activeCourse.name} ${module == 0 ? 1 : 2}`,
      };
      updateFeeData()
      toast.success('Fee status updated successfully')
      setOpen(false)
      await addAdminActivity(activityOptions, location)
      await changeStudentCourse(data.email, data.courses)
      await sendEmail({
        toEmail: data.email,
        subject: "EU Portal | Response to a fee submission report.",
        feeStatus: status,
        courseName: activeCourse.name,
        courseType: activeCourse.type,
        courseModule: module == 0 ? 1 : 2,
        reason: reason === "Other" ? textBox : reason,
        name: data.fullName,
        whatsappLink: activeCourse.whatsappLink,
        timings: getFormattedTimings(activeCourse),
      })
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoading(false)
      setOpen(false)
    }
  }

  const updateFeeData = () => {
    const studentMainDataIndex = students.findIndex((student) => student.email === data.email)
    const studentsLocalDataIndex = courseStudents.findIndex((student) => student.email === data.email)
    setStudents(previousStudents => {
      const newStudent = [...previousStudents];
      students[studentMainDataIndex] = data;
      return newStudent;
    });
    updateStudents(previousStudents => {
      const newStudent = [...previousStudents];
      courseStudents[studentsLocalDataIndex] = data;
      return newStudent;
    });
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'fullName',
    },
    {
      title: 'Student ID',
      dataIndex: 'studentId',
    },
    {
      title: 'Fee Module',
      render: () => module === 0 ? 'First' : 'Second'
    },
  ];

  useEffect(() => {
    if (data?.courses) {
      const fee = data.courses[data.courseIndex].feeScreenshots[module]
      console.log("fee", fee)
      const status = fee?.status
      setFeeStatus(status)
      setFeeImage(fee?.image)
    }
  }, [data])

  return (
    <CommonModal
      isOpen={open}
      toggler={() => setOpen(false)}
      showCloseBtn={false}
      successText={loading ? <Loader /> : 'Save'}
      title='Update Fee'
      success={() => saveStudentUpdatedFee()}
      disabled={loading}
      bodyClass='full-screen-modal'
      size="md"
    >
      <div className="fee-data ant-design-table not-margin">
        <Table
          columns={columns}
          pagination={false}
          loading={!data}
          dataSource={[data]}
        />
      </div>
      <div>
        <Btn attrBtn={{
          onClick: () => setShowImage(!showImage),
          color: "primary",
          className: "m-t-20 m-b-20 w-100"
        }}>
          {showImage ? 'Close' : "Open"} Fee Image</Btn>
        {showImage && <div>
          <img src={feeImage} className="w-100" />
        </div>}
      </div>
      <div className="m-t-15">
        {[PENDING, VERIFIED, NOT_VERIFIED].map((item, idx) => (
          <div className="" key={idx}>
            <Label className="d-block f-16 f-w-600" for="edo-ani">
              <Input value={item}
                id={idx}
                onChange={feeStatusChangeHandler}
                type="radio"
                checked={item === feeStatus}
                className="radio_animated"
              />{item}
            </Label>
          </div>
        ))}

        {feeStatus === "notVerified" && (
          <div>
            <p className="text-base ">Select a reason to:</p>
            {screenShotReasons.map((item, idx) => (
              <div key={idx} className="fee-reasons">
                <Input value={item}
                  id={item}
                  onChange={reasonChangeHandler}
                  type="radio"
                  checked={item === reason}
                  className="radio_animated"
                />
                <Label className="d-block f-16 f-w-600" htmlFor={item}>
                  <span>
                    {item}
                  </span>
                </Label>
              </div>
            ))}
          </div>
        )}
        {openTextBox && (
          <textarea
            value={textBox}
            onChange={(e) => setTextBox(e.target.value)}
            rows={4}
            placeholder="Enter your reason for fee failed"
            className="form-control"
          />
        )}
      </div>
    </CommonModal>)
}

export default FeeUpdate